// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3jWj3","button":"styles_button__1hYs2","footer":"styles_footer__3_Lfx","checkbox":"styles_checkbox__1rXz0"};